import { HttpError, parseRetryAfterHeader } from '@pin/client-http-utils';
import { retry, timer } from 'rxjs';

export function jsonSuccessSelector<T = any>(response: Response): Promise<T> {
  if (!response.ok) {
    throw new HttpError(response);
  }
  return response.json();
}

export function retryFetch<T>(count: number) {
  return retry<T>({
    count,
    delay: (error, retryCount) => {
      const exponentialBackoff = 1_000 * retryCount ** 2;
      if (error instanceof HttpError) {
        return timer(
          Math.max(
            parseRetryAfterHeader(error.response) ?? 0,
            exponentialBackoff
          )
        );
      }
      return timer(exponentialBackoff);
    },
    resetOnSuccess: true,
  });
}
